import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterLink} from '@angular/router';

import {TranslateModule} from '@ngx-translate/core';

import {PayrollInputAdminComponent} from './payroll-input-admin/payroll-input-admin.component';
import {PersonMasterDataAdminComponent} from './person-master-data-admin/person-master-data-admin.component';
import {SdcLogComponent} from './sdc-log/sdc-log.component';
import {SdcLogsListComponent} from './sdc-logs-list/sdc-logs-list.component';
import {SdcPayrollFormComponent} from './sdc-payroll-form/sdc-payroll-form.component';
import {SdcPersonDataCardComponent} from './sdc-person-form/sdc-person-data-card.component';
import {SdcPersonDataItemsComponent} from './sdc-person-form/sdc-person-data-items.component';
import {
  SdcPersonFeedbackEnrichedResponseComponent
} from './sdc-person-form/sdc-person-feedback/sdc-person-feedback-enriched-response.component';
import {
  SdcPersonFeedbackErrorComponent
} from './sdc-person-form/sdc-person-feedback/sdc-person-feedback-error.component';
import {SdcPersonFeedbackComponent} from './sdc-person-form/sdc-person-feedback/sdc-person-feedback.component';
import {SdcPersonFormComponent} from './sdc-person-form/sdc-person-form.component';
import {PersonPayrollLogsListComponent} from './sdc-person-logs-list/person-payroll-logs-list.component';
import {SdcStatusesComponent} from './sdc-status/sdc-statuses.component';

import {TabsModule} from 'ngx-bootstrap/tabs';
import {ModalModule} from '../modal/modal.module';
import {PayPeriodSelectorBarComponent} from '../pay-period-selector-bar/pay-period-selector-bar.component';
import {PipesModule} from '../pipes/pipes.module';
import {TableModule} from '../ui/table/table.module';
import {UiModule} from '../ui/ui.module';

@NgModule({
  imports: [
    CommonModule,
    ModalModule,
    TranslateModule,
    PipesModule,
    TableModule,
    ReactiveFormsModule,
    FormsModule,
    UiModule,
    RouterLink,
    TabsModule,
    PayPeriodSelectorBarComponent
  ],
  declarations: [
    PersonMasterDataAdminComponent,
    PayrollInputAdminComponent,
    SdcLogComponent,
    SdcStatusesComponent,
    PersonPayrollLogsListComponent,
    SdcLogsListComponent,
    SdcPersonFormComponent,
    SdcPayrollFormComponent,
    SdcPersonDataCardComponent,
    SdcPersonDataItemsComponent,
    SdcPersonFeedbackComponent,
    SdcPersonFeedbackEnrichedResponseComponent,
    SdcPersonFeedbackErrorComponent
  ],
  exports: [
    PersonMasterDataAdminComponent,
    PayrollInputAdminComponent,
    SdcLogComponent,
    SdcStatusesComponent,
    PersonPayrollLogsListComponent,
    SdcLogsListComponent,
    SdcPersonFormComponent,
    SdcPayrollFormComponent,
    SdcPersonDataCardComponent,
    SdcPersonDataItemsComponent,
    SdcPersonFeedbackComponent,
    SdcPersonFeedbackEnrichedResponseComponent
  ],
})
export class SdconnectModule {
}
